/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const BarChartHorizontal = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M3 3v18h18" }],
    ["path", { d: "M7 16h8" }],
    ["path", { d: "M7 11h12" }],
    ["path", { d: "M7 6h3" }]
  ]
];

export { BarChartHorizontal as default };
//# sourceMappingURL=bar-chart-horizontal.js.map
